<template>
  <section :id="data?.anchor_id ? data.anchor_id : null" class="imageGallery container" :class="{'singleImage': mainImages?.length === 1, 'withoutImages': !mainImages?.length}">
    <template v-for="item in mainImages">
      <FlarePicture
        v-if="item"
        :src="{
          1920: { src: item, width: 800, height: 660, size: 'both', crop: 'fill' },
        }"
        :alt="item.alt"
      />
    </template>
    
    <div class="imageGallery__Text">
      <h2 v-text="data.title" />
      <p v-text="data.lead" />
      <Button secondary medium @click="open('gallery')">
        <template #prepend>
          <Icon name="photo-gallery" />
        </template>
        {{ $t('seeGallery') }}
      </Button>
    </div>
  </section>

  <Modal v-show="dialogs.gallery" v-model="dialogs.gallery" class="modal__Gallery">
    <template v-for="item in data.gallery" :key="item?.id">
      <FlarePicture v-if="item"
        :src="{
          1920: { src: item.image || item, width: 1000 },
        }"
        :alt="item.image?.alt || item.alt"
      />
      <p v-if="item.description" v-text="item.description" />
    </template>
  </Modal>
</template>

<script setup>
  const props = defineProps({
    data: {}
  });

  const dialogs = reactive({
    gallery: false
  });
  const { open } = useModal(dialogs);

  const mainImages = computed(() => props.data.gallery.slice(0, 3));
</script>

<style lang="scss">
  // @import url('@/assets/styles/components/blocks/_imageGallery.scss');
</style>